module.exports = __webpack_public_path__ + "static/img/logo.7678e23b.png";